import { GET_ALL_STATE_LIST_SUCCESS, GET_ALL_STATE_LIST_FAILURE } from "../constants/MyM";
import { getApi } from "../../utils/apiCall";

const getAllStateListSuccess = (data) => {
  return {
    type: GET_ALL_STATE_LIST_SUCCESS,
    payload: data,
  };
};

const getAllStateListFailure = (data) => {
  return {
    type: GET_ALL_STATE_LIST_FAILURE,
    payload: data,
  };
};

export const getStateInfo = () => {
  return async (dispatch, getState) => {
    const { error, result } = await getApi(`/get_all_statelist`);
    if (!error) {
      return dispatch(getAllStateListSuccess(result));
    }
    return dispatch(getAllStateListFailure(result));
  };
};
